<template>
  <div class="case">
    <banner img="@/assets/img/bgtop.jpg" title="经典案例" />
<!--    <div style="width: 70%;margin: 0 auto">-->

      <div style="height: 400px;display: flex;width: 70%;margin: 0 auto;flex-direction: column;margin-top: 20px">
        <div style="font-weight: bold;font-size: 20px;text-align: center;height: 30px">产品介绍</div>
        <div style="display: flex;height: 370px">
          <div style="width: 40%;height: 100%;display: flex;justify-content: center;align-items: center">
            <div style="height: 50%;width: 80%;    display: flex;
          width: 80%;
          justify-content: center;
          align-items: center;">
              <img style="width: auto;
          height: auto;
          max-height: 100%;
          max-width: 100%"
                   src="../assets/img/ty.png"/>
            </div>
          </div>
          <div style="width: 60%;height: 100%;display: flex;justify-content: center;align-items: center">
            <div style="height: 50%;width: 90%">
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;围绕着我国教育部门单位及高校专业教学的人才培养需求，红亚科技将为客户提供优质的大数据及网络安全竞赛服务。截止到目前，我司已多次承办国家级、省级、地方级、企业、高校等级别的竞赛。竞赛服务根据举办单位的要求及赛事规模进行定制，包括竞赛文案的编写、宣传彩页的制作、竞赛服装的设计、竞赛餐饮的提供等。同时提供专业的竞赛平台与赛前培训服务，切实保障参赛选手能够熟练掌握竞赛核心知识。
                赛题的设计也是根据客户需求进行定制，主要围绕着大数据生态系统的构建与大数据分析挖掘手段、网络安全AWD对抗核心技术知识进行设计，致力于通过竞赛提升参赛选手的知识技能水平。
              </p>


            </div>

          </div>
        </div>

      </div>
      <div style="height: 500px;display: flex;width: 100%;justify-content: center;background-color:#f6f8fe;">
        <img src="../assets/img/sht.jpg"/>
      </div>
      <div style="height: 500px;display: flex;width: 70%;margin: 0 auto;
      justify-content: center;align-items: center;flex-direction: column ">
        <div style="margin-bottom: 30px;font-weight: bold;font-size: 20px">系统截图</div>
        <div style="height: 50%;width: 100%">
          <MySwipper />
        </div>

      </div>
<!--    </div>-->
  </div>
</template>
<script>
import Banner from "../components/Banner";
import MySwipper from "../components/MySwipper"
export default {
  components: {
    Banner,
    MySwipper
  },
  data() {
    return {
      loading: true,
      caseList: []
    };
  },
  mounted() {
    window.console.log("case");
    this.$http
      .get("Cases/GetCasesAll")
      .then(response => {
        //console.log(response);
        this.caseList = response.data;
        //window.console.log(this.caseList);
        this.loading = false;
      })
      .catch(function(error) {
        window.console.log(error);
      });
  }
};
</script>

 <style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: white;
  flex-direction: row;
  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>
